export const PROGRAM_MEMBERS_ENDPOINTS = {
  listRoles: 'user-role/list-roles',
  listAssignedMembers: 'admin/list-assigned-members-by-program',
  createManager: 'admin/create-manager',
  updateManagerStatus: 'admin/update-manager-status',
  assignMembers: 'admin/assign-members-to-program',
  // Add new endpoints here as needed
};
